import { Utensils } from '@hungryroot/icons';
import { Heading, Paragraph } from '@hungryroot/ramen';
import styles from './ServingSizeIcon.module.css';

interface Props {
  testid?: string;
  pairingServingSize: number | undefined;
  customerPlanServingSize: number | undefined;
  replaceIconAndText?: boolean;
  additionalText?: string;
}

export function ServingSizeIcon(props: Props) {
  const {
    pairingServingSize,
    customerPlanServingSize,
    replaceIconAndText,
    additionalText,
  } = props;

  const recipeIsOutsidePlanSize =
    customerPlanServingSize &&
    pairingServingSize &&
    pairingServingSize !== customerPlanServingSize;

  if (replaceIconAndText) {
    const servingText = (
      <span className={styles.icon}>
        <Utensils /> {pairingServingSize} serv.
      </span>
    );

    if (recipeIsOutsidePlanSize) {
      return <Heading variant="H6">{servingText}</Heading>;
    }
    return servingText;
  }

  return (
    <span
      aria-label={`Serves ${pairingServingSize}`}
      className={styles.additive}
    >
      <span className={styles.dot}>•</span>
      <Paragraph variant="caption" className={styles.icon}>
        <Utensils />
        {additionalText ? additionalText : pairingServingSize}
      </Paragraph>
    </span>
  );
}
